import React, { Component } from "react";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import { ACTIVITY_TYPE } from "../../../../common/Constants";

class TabDataKeteranganFJB extends Component {
  setValue = (name, value) => {
    const { onSetSpesificData } = this.props;
    onSetSpesificData("dataKeterangan", name, value);
  };

  render() {
    const { formData, activityType } = this.props;
    const dataKeterangan = formData?.dataKeterangan || {};
    const isReadOnly = activityType === ACTIVITY_TYPE.VIEW;

    return (
      <React.Fragment>
        <div className="grid grid-2x gap-20px grid-mobile-none">
          <div id="grid-1">
            <SimpleTextArea
              id="input_text_keterangan"
              name="keterangan"
              label="Keterangan"
              readOnly={isReadOnly}
              value={dataKeterangan.keterangan}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TabDataKeteranganFJB;
